import {
  requests
} from '../../../../api/agent'


export default {
  GetCollectiveAppeals: (params) => requests.getWithParams('/Appeal/getCollectiveAppeals', params),
  GetCollectiveAppealUsers: (params) => requests.getWithParams('/Appeal/GetCollectiveAppealUsers', params),
  GetOrgCollectiveAppealUsers: (params) => requests.getWithParams('/Appeal/GetOrgCollectiveAppealUsers', params),
  GetOrgCollectiveAppealUserList: (params) => requests.getWithParams('/Appeal/GetOrgCollectiveAppealUserList', params),
  SubmitAppeal: (params) => requests.post('/Appeal/submitAppeal', params),
  JoinToCollectiveAppeal: (params) => requests.post('/Appeal/joinToAppeal', params),
  InviteUserToAppeal: (params) => requests.post('/Appeal/inviteUserToAppeal', params),
  DeclineInvitation: (params) => requests.post('/Appeal/declineInvitation', params),
  CheckUserExistInAppeal: (params) => requests.getWithParams('/Appeal/checkUserExistInAppeal', params),
  GetInvitedUsers:(params) => requests.getWithParams('/Appeal/getInvitedUsers', params),
  CheckUserHaveInvite:(params) => requests.getWithParams('/Appeal/checkUserHaveInvite', params),
  GetPendnigAppealData:(params) => requests.getWithParams('/Appeal/getPendnigAppealData', params),
  
}
